import React from 'react';
import PropTypes from 'prop-types';
import t from 'translate';
import Dropzone from 'react-dropzone';
import clsx from 'clsx';

import image from '../../../../images/image.png';

const DropzoneRender = ({ disabled, input, id, accept, onDropFunc, multiple, dropText }) => (
  <Dropzone
    disabled={disabled}
    className="dropzone"
    accept={accept}
    id={id}
    name={input?.name}
    onDrop={onDropFunc}
    multiple={multiple}
  >
    {({ getRootProps, getInputProps }) => (
      <div {...getRootProps()} className={clsx('dropzone-target', { disabled })}>
        <div className="dropzone-target-content">
          <input {...getInputProps()} />
          <div className="dropzone-logo-wrapper">
            <img src={image} alt="dropzone" />
          </div>
          <div className="dropzone-title">{t(dropText)}</div>
        </div>
      </div>
    )}
  </Dropzone>
);

DropzoneRender.defaultProps = {
  disabled: false,
  multiple: true,
  accept: '',
  dropText: 'form.dropzone',
  input: null,
};

DropzoneRender.propTypes = {
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  accept: PropTypes.string,
  dropText: PropTypes.string,
  input: PropTypes.object,
  id: PropTypes.string.isRequired,
  onDropFunc: PropTypes.func.isRequired,
};

export default DropzoneRender;
